import { render, staticRenderFns } from "./OdpisPP.vue?vue&type=template&id=37c6988e&"
import script from "./OdpisPP.vue?vue&type=script&lang=ts&"
export * from "./OdpisPP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports